/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlEndpointGroupDTO } from './ControlEndpointGroupDTO';
import {
    ControlEndpointGroupDTOFromJSON,
    ControlEndpointGroupDTOFromJSONTyped,
    ControlEndpointGroupDTOToJSON,
} from './ControlEndpointGroupDTO';
import type { ControlOperatingSystemCategory } from './ControlOperatingSystemCategory';
import {
    ControlOperatingSystemCategoryFromJSON,
    ControlOperatingSystemCategoryFromJSONTyped,
    ControlOperatingSystemCategoryToJSON,
} from './ControlOperatingSystemCategory';

/**
 * 
 * @export
 * @interface ControlEndpoint
 */
export interface ControlEndpoint {
    /**
     * 
     * @type {boolean}
     * @memberof ControlEndpoint
     */
    contained: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlEndpoint
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEndpoint
     */
    displayName: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlEndpoint
     */
    domainController: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlEndpoint
     */
    edrSourceId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlEndpoint
     */
    groupChatOpsEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlEndpoint
     */
    groupContainmentEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlEndpoint
     */
    groupSourceSystemUpdates: boolean;
    /**
     * 
     * @type {Array<ControlEndpointGroupDTO>}
     * @memberof ControlEndpoint
     */
    groups: Array<ControlEndpointGroupDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof ControlEndpoint
     */
    groupsSynced: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlEndpoint
     */
    hva: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlEndpoint
     */
    hvaOverriddenByUser?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlEndpoint
     */
    id: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ControlEndpoint
     */
    integrationId: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof ControlEndpoint
     */
    lastSeenAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlEndpoint
     */
    live?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlEndpoint
     */
    managed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlEndpoint
     */
    mdmSourceId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlEndpoint
     */
    mobile: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlEndpoint
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEndpoint
     */
    operatingSystem?: string;
    /**
     * 
     * @type {ControlOperatingSystemCategory}
     * @memberof ControlEndpoint
     */
    operatingSystemCategory?: ControlOperatingSystemCategory;
    /**
     * 
     * @type {string}
     * @memberof ControlEndpoint
     */
    privateIpAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEndpoint
     */
    publicIpAddress?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ControlEndpoint
     */
    raw?: { [key: string]: any; };
    /**
     * 
     * @type {boolean}
     * @memberof ControlEndpoint
     */
    server: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlEndpoint
     */
    teamId: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEndpoint
     */
    updatedAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlEndpoint
     */
    workstation: boolean;
}

/**
 * Check if a given object implements the ControlEndpoint interface.
 */
export function instanceOfControlEndpoint(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "contained" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "displayName" in value;
    isInstance = isInstance && "domainController" in value;
    isInstance = isInstance && "groupChatOpsEnabled" in value;
    isInstance = isInstance && "groupContainmentEnabled" in value;
    isInstance = isInstance && "groupSourceSystemUpdates" in value;
    isInstance = isInstance && "groups" in value;
    isInstance = isInstance && "groupsSynced" in value;
    isInstance = isInstance && "hva" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "integrationId" in value;
    isInstance = isInstance && "mobile" in value;
    isInstance = isInstance && "server" in value;
    isInstance = isInstance && "teamId" in value;
    isInstance = isInstance && "workstation" in value;

    return isInstance;
}

export function ControlEndpointFromJSON(json: any): ControlEndpoint {
    return ControlEndpointFromJSONTyped(json, false);
}

export function ControlEndpointFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEndpoint {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'contained': json['contained'],
        'createdAt': json['createdAt'],
        'displayName': json['displayName'],
        'domainController': json['domainController'],
        'edrSourceId': !exists(json, 'edrSourceId') ? undefined : json['edrSourceId'],
        'groupChatOpsEnabled': json['groupChatOpsEnabled'],
        'groupContainmentEnabled': json['groupContainmentEnabled'],
        'groupSourceSystemUpdates': json['groupSourceSystemUpdates'],
        'groups': ((json['groups'] as Array<any>).map(ControlEndpointGroupDTOFromJSON)),
        'groupsSynced': json['groupsSynced'],
        'hva': json['hva'],
        'hvaOverriddenByUser': !exists(json, 'hvaOverriddenByUser') ? undefined : json['hvaOverriddenByUser'],
        'id': json['id'],
        'integrationId': json['integrationId'],
        'lastSeenAt': !exists(json, 'lastSeenAt') ? undefined : json['lastSeenAt'],
        'live': !exists(json, 'live') ? undefined : json['live'],
        'managed': !exists(json, 'managed') ? undefined : json['managed'],
        'mdmSourceId': !exists(json, 'mdmSourceId') ? undefined : json['mdmSourceId'],
        'mobile': json['mobile'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'operatingSystem': !exists(json, 'operatingSystem') ? undefined : json['operatingSystem'],
        'operatingSystemCategory': !exists(json, 'operatingSystemCategory') ? undefined : ControlOperatingSystemCategoryFromJSON(json['operatingSystemCategory']),
        'privateIpAddress': !exists(json, 'privateIpAddress') ? undefined : json['privateIpAddress'],
        'publicIpAddress': !exists(json, 'publicIpAddress') ? undefined : json['publicIpAddress'],
        'raw': !exists(json, 'raw') ? undefined : json['raw'],
        'server': json['server'],
        'teamId': json['teamId'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
        'workstation': json['workstation'],
    };
}

export function ControlEndpointToJSON(value?: ControlEndpoint | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'contained': value.contained,
        'createdAt': value.createdAt,
        'displayName': value.displayName,
        'domainController': value.domainController,
        'edrSourceId': value.edrSourceId,
        'groupChatOpsEnabled': value.groupChatOpsEnabled,
        'groupContainmentEnabled': value.groupContainmentEnabled,
        'groupSourceSystemUpdates': value.groupSourceSystemUpdates,
        'groups': ((value.groups as Array<any>).map(ControlEndpointGroupDTOToJSON)),
        'groupsSynced': value.groupsSynced,
        'hva': value.hva,
        'hvaOverriddenByUser': value.hvaOverriddenByUser,
        'id': value.id,
        'integrationId': value.integrationId,
        'lastSeenAt': value.lastSeenAt,
        'live': value.live,
        'managed': value.managed,
        'mdmSourceId': value.mdmSourceId,
        'mobile': value.mobile,
        'name': value.name,
        'operatingSystem': value.operatingSystem,
        'operatingSystemCategory': ControlOperatingSystemCategoryToJSON(value.operatingSystemCategory),
        'privateIpAddress': value.privateIpAddress,
        'publicIpAddress': value.publicIpAddress,
        'raw': value.raw,
        'server': value.server,
        'teamId': value.teamId,
        'updatedAt': value.updatedAt,
        'workstation': value.workstation,
    };
}

